module.exports = __webpack_public_path__ + "img/right-person.c554cab9.png";